/* eslint-disable */
export default {
  init() {
    // JavaScript to be fired on the home page
    $(document).ready(function() {

      $('#slider-home').slick({
        arrows: false,
        dots: true
      });

      $('#slider-home-mobile').slick({
        arrows: true,
        dots: false,
        prevArrow: '<button type="button" class="slick-prev"></button>',
        nextArrow: '<button type="button" class="slick-next"></button>',
      });

      $('#guest-slider').slick({
        arrows: true,
        dots: false,
        centerMode: true,
        centerPadding: '50px',
        slidesToShow: 1,
        variableWidth: true,
        infinite: false,
        initialSlide: 1,
        speed: 1000,
        prevArrow: '<button type="button" class="slick-prev"></button>',
        nextArrow: '<button type="button" class="slick-next"></button>',
      });

      $('#video-slider').slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        prevArrow: '<button type="button" class="slick-prev"></button>',
        nextArrow: '<button type="button" class="slick-next"></button>',
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            }
          }
        ]
      })

      function playHomeVideo(){
        $('.video-slider .video-item').click(function(e){
          e.preventDefault();
          $(this).find('.youtube-video-place').html('<iframe width="420" height="315" allowfullscreen frameborder="0" src="' + $(this).find('.youtube-video-place').data('yt-url') + '?autoplay=1"></iframe>');
          // $('iframe', this)[0].src += '?autoplay=1';
          $(this).addClass('is-playing');
        });
      }

      playHomeVideo();

      $(window).resize(function(){
        logo_br();
      })

      logo_br();

      function logo_br(){
        if($(window).width() < 900){
          $('.logos-home br').css('display', 'none');
        }
      }

      $('.player .sound').click(function(){
        if( $(this).hasClass('sound-on') ){
          $('+ video', this).prop('muted', true);
          $(this).removeClass('sound-on');
          $('i', this).removeClass('fa-volume-up').addClass('fa-volume-mute');
        }
        else {
          $('+ video', this).prop('muted', false);
          $(this).addClass('sound-on');
          $('i', this).removeClass('fa-volume-mute').addClass('fa-volume-up');
        }
      });

      setTimeout(function() {
        $('.video-wrapper').removeClass('anim-onload');
      }, 5000);

    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};

/* eslint-enable */



// WEBPACK FOOTER //
// ./scripts/routes/home.js